<template>
  <!-- 供应商二赔金额填写 -->
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="80%"
  >
    <el-table :data="tableData" v-loading="tableLoading" border stripe>
      <!-- 序号 -->
      <el-table-column type="index" label="序号" width="60" align="center">
      </el-table-column>
      <!-- 责任类型 -->
      <el-table-column
        prop="faultPartNumber"
        label="故障件件号"
        align="center"
        min-width="160px"
      >
      </el-table-column>
      <el-table-column
        prop="faultPartName"
        label="故障件名称"
        align="center"
        min-width="160px"
      />
      <el-table-column
        prop="responsibilitySupplier"
        label="供应商名称"
        align="center"
        min-width="160px"
      >
      </el-table-column>
      <el-table-column
        prop="responsibilitySupplierCode"
        label="供应商代码"
        align="center"
        min-width="160px"
      >
      </el-table-column>
      <el-table-column
        prop="purchasePrice"
        label="零部件采购价"
        align="center"
        min-width="160px"
      >
        <template slot-scope="scope">
          <div
            v-if="operateType === 'edit'"
            style="position: relative; width: fit-content;"
          >
            <el-input-number
              v-model="scope.row.purchasePrice"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              ￥
            </div>
          </div>
          <span v-else>
            {{
              scope.row.purchasePrice === 0 || scope.row.purchasePrice
                ? "￥"
                : ""
            }}{{ scope.row.purchasePrice }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="supplierMaterRate"
        label="供应商材料费费率"
        align="center"
        min-width="160px"
      >
        <template slot-scope="scope">
          <div
            v-if="operateType === 'edit'"
            style="position: relative; width: fit-content;"
          >
            <el-input-number
              v-model="scope.row.supplierMaterRate"
              :controls="false"
              :precision="3"
            ></el-input-number>
          </div>
          <span v-else> {{ scope.row.supplierMaterRate }} </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="replaceNum"
        label="更换数量"
        align="center"
        min-width="160px"
      >
      </el-table-column>
      <el-table-column
        prop="materPrice"
        label="材料费用"
        align="center"
        min-width="160px"
      >
        <template slot-scope="scope">
          {{ scope.row.materPrice === 0 || scope.row.materPrice ? "￥" : ""
          }}{{ scope.row.materPrice }}
        </template>
      </el-table-column>
      <el-table-column
        prop="supplierManageRate"
        label="供应商管理费费率"
        align="center"
        min-width="160px"
      >
        <template slot-scope="scope">
          <div
            v-if="operateType === 'edit'"
            style="position: relative; width: fit-content;"
          >
            <el-input-number
              v-model="scope.row.supplierManageRate"
              :controls="false"
              :precision="3"
            ></el-input-number>
          </div>
          <span v-else> {{ scope.row.supplierManageRate }} </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="materTotalPrice"
        label="材料总费用"
        align="center"
        min-width="160px"
      >
        <template slot-scope="scope">
          {{
            scope.row.materTotalPrice === 0 || scope.row.materTotalPrice
              ? "￥"
              : ""
          }}{{ scope.row.materTotalPrice }}
        </template>
      </el-table-column>
      <el-table-column
        prop="managePrice"
        label="管理费用"
        align="center"
        min-width="160px"
      >
        <template slot-scope="scope">
          {{ scope.row.managePrice === 0 || scope.row.managePrice ? "￥" : ""
          }}{{ scope.row.managePrice }}
        </template>
      </el-table-column>
      <el-table-column
        prop="manageTotalPrice"
        label="管理总费用"
        align="center"
        min-width="160px"
      >
        <template slot-scope="scope">
          {{
            scope.row.manageTotalPrice === 0 || scope.row.manageTotalPrice
              ? "￥"
              : ""
          }}{{ scope.row.manageTotalPrice }}
        </template>
      </el-table-column>
      <el-table-column
        prop="hour"
        label="工时"
        align="center"
        min-width="160px"
      >
      </el-table-column>
      <el-table-column
        prop="hourPrice"
        label="工时单价"
        align="center"
        min-width="160px"
      >
        <template slot-scope="scope">
          <div
            v-if="
              operateType === 'edit' &&
                scope.row.faultPartNumber === scope.row.mainFaultPartNumber
            "
            style="position: relative; width: fit-content;"
          >
            <el-input-number
              v-model="scope.row.hourPrice"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              ￥
            </div>
          </div>
          <span v-else>
            {{ scope.row.hourPrice === 0 || scope.row.hourPrice ? "￥" : ""
            }}{{ scope.row.hourPrice }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="hourTotalPrice"
        label="工时总费用"
        align="center"
        min-width="160px"
      >
        <template slot-scope="scope">
          {{
            scope.row.hourTotalPrice === 0 || scope.row.hourTotalPrice
              ? "￥"
              : ""
          }}{{ scope.row.hourTotalPrice }}
        </template>
      </el-table-column>
      <el-table-column
        prop="freightPrice"
        label="运费"
        align="center"
        min-width="160px"
      >
        <template slot-scope="scope">
          <div
            v-if="operateType === 'edit'"
            style="position: relative; width: fit-content;"
          >
            <el-input-number
              v-model="scope.row.freightPrice"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              ￥
            </div>
          </div>
          <span v-else>
            {{
              scope.row.freightPrice === 0 || scope.row.freightPrice
                ? "￥"
                : ""
            }}{{ scope.row.freightPrice }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="tariffPrice"
        label="关税"
        align="center"
        min-width="160px"
      >
        <template slot-scope="scope">
          <div
            v-if="operateType === 'edit'"
            style="position: relative; width: fit-content;"
          >
            <el-input-number
              v-model="scope.row.tariffPrice"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              ￥
            </div>
          </div>
          <span v-else>
            {{ scope.row.tariffPrice === 0 || scope.row.tariffPrice ? "￥" : ""
            }}{{ scope.row.tariffPrice }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="travelPrice"
        label="差旅费"
        align="center"
        min-width="160px"
      >
        <template slot-scope="scope">
          <div
            v-if="operateType === 'edit'"
            style="position: relative; width: fit-content;"
          >
            <el-input-number
              v-model="scope.row.travelPrice"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              ￥
            </div>
          </div>
          <span v-else>
            {{ scope.row.travelPrice === 0 || scope.row.travelPrice ? "￥" : ""
            }}{{ scope.row.travelPrice }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="otherPrice"
        label="其他费用"
        align="center"
        min-width="160px"
      >
        <template slot-scope="scope">
          <div
            v-if="operateType === 'edit'"
            style="position: relative; width: fit-content;"
          >
            <el-input-number
              v-model="scope.row.otherPrice"
              :controls="false"
              :precision="2"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              ￥
            </div>
          </div>
          <span v-else>
            {{ scope.row.otherPrice === 0 || scope.row.otherPrice ? "￥" : ""
            }}{{ scope.row.otherPrice }}
          </span>
        </template>
      </el-table-column>
      <!-- 总金额 -->
      <el-table-column
        v-if="operateType === 'look'"
        prop="secondDamages"
        label="总金额"
        align="center"
        min-width="120px"
      >
        <template slot-scope="scope">
          {{ scope.row.secondDamages ? "￥" + scope.row.secondDamages : "" }}
        </template>
      </el-table-column>
      <!-- 更新人 -->
      <el-table-column
        v-if="operateType === 'look'"
        prop="updateName"
        label="更新人"
        align="center"
        min-width="160px"
      >
      </el-table-column>
      <!-- 更新时间 -->
      <el-table-column
        v-if="operateType === 'look'"
        prop="updateTime"
        label="更新时间"
        align="center"
        min-width="160px"
      >
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button
        v-if="title === '供应商二赔金额填写'"
        class="lang-but" type="primary"
        :loading="btnLoading"
        @click="handleConfirm"
        >确定</el-button
      >
      <el-button class="lang-but" type="primary" plain @click="handleClose">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  updateSecondCompensationApi,
  secondCompensationHistoryListApi
} from "@/api/seek";

export default {
  name: "secondCompensationDialog",
  data() {
    return {
      dialogVisible: false,
      btnLoading: false,
      tableLoading: false,
      title: "",
      operateType: "",
      tableData: []
    };
  },
  methods: {
    async init(title, data) {
      this.title = title;
      this.tableData = [];
      this.tableLoading = true;
      this.dialogVisible = true;

      if (title === "供应商二赔金额填写") {
        this.operateType = "edit";
        this.tableData = [
          { ...data, purchasePrice: data.purchasePrice ?? undefined }
        ];
      } else {
        this.operateType = "look";
        try {
          const res = await secondCompensationHistoryListApi({
            responsibilityPartId: data.responsibilityPartId
          });
          this.tableData = res.data;
        } catch (error) {}
      }
      this.tableLoading = false;
    },
    async handleConfirm() {
      this.btnLoading = true;
      try {
        const res = await updateSecondCompensationApi(this.tableData[0]);
        if (res.status === "0") {
          this.$DonMessage.success(res.message);
          this.$emit("success");
          this.dialogVisible = false;
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {}
      this.btnLoading = false;
    },
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>
